import React from "react";
import Seat from "./Seat";
import { SeatRowProps } from "./types";
import ExitRow from "./ExitRow";

const SeatRow: React.FC<SeatRowProps> = ({
  PlanColumn,
  rowData,
  onSeatSelect,
  selectedSeats = [],
  totalTravellers,
}) => {
  // Check if any seat in the row is an exit row seat
  const hasExitRow = rowData.lstColumn?.some((seat: any) =>
    seat.lstFacility?.some((facility: any) => facility.Type === "EXITROW")
  );

  // Normalize seat layout based on PlanColumn
  const normalizedSeats = PlanColumn?.map((col, index) => {
    if (col === "") {
      return { isAisle: true }; // special flag to render aisle gap
    }

    const seat = rowData.lstColumn?.find(
      (s) => typeof s.SeatNumber === "string" && s.SeatNumber.endsWith(col)
    );

    return seat ?? { SeatNumber: null }; // placeholder for missing seat
  });

  return (
    <div className="flex flex-col">
      {hasExitRow && (
        <div className="flex justify-between mb-1">
          <div className="exit-icon exit-left mx-2">
            <ExitRow position="left" />
          </div>
          <div className="exit-icon exit-right mx-2">
            <ExitRow position="right" />
          </div>
        </div>
      )}

      <div className="flex items-center seatRow">
        <div
          className="w-6 text-center text-sm text-gray-500"
          style={{ width: "31px" }}
        >
          {rowData.RowNumber}
        </div>

        {normalizedSeats?.map((seat: any, index: number) => {
          if (seat.isAisle) {
            return <div key={`aisle-${index}`} className="w-4" />;
          }

          return (
            <Seat
              key={seat.SeatNumber || `placeholder-${index}`}
              seat={seat}
              onSelect={onSeatSelect}
              isSelected={selectedSeats.some(
                (s) => s.SeatNumber === seat?.SeatNumber
              )}
              totalTravellers={totalTravellers}
              selectedSeats={selectedSeats}
            />
          );
        })}

        <div
          className="w-6 text-center text-sm text-gray-500"
          style={{ width: "31px" }}
        >
          {rowData.RowNumber}
        </div>
      </div>
    </div>
  );
};

export default SeatRow;
